/* AFORDA Recently Viewed: browser-local history with up-to-date Shopify product data.
   No app, cookies, or server-side customer profile required. */
(() => {
  const KEY = 'aforda:recently-viewed:v1';
  const SELECTOR = '[data-aforda-recently-viewed]';
  const MAX_STORED = 20;
  const validHandle = (handle) =>
    typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(handle) && handle.length <= 160;

  const uniqueHandles = (values) => {
    const seen = new Set();
    return (Array.isArray(values) ? values : []).filter((handle) => {
      if (!validHandle(handle) || seen.has(handle)) return false;
      seen.add(handle);
      return true;
    });
  };

  function readHistory() {
    try { return uniqueHandles(JSON.parse(localStorage.getItem(KEY))); }
    catch (_) { return []; }
  }

  function writeHistory(handles) {
    try { localStorage.setItem(KEY, JSON.stringify(handles)); }
    catch (_) { /* Graceful fallback when browser storage is disabled. */ }
  }

  function shopImageURL(value) {
    if (typeof value !== 'string' || !value) return '';
    try {
      const url = new URL(value.startsWith('//') ? location.protocol + value : value, location.href);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      if (url.origin !== location.origin &&
          url.hostname !== 'cdn.shopify.com' &&
          !url.hostname.endsWith('.shopifycdn.net')) return '';
      url.searchParams.set('width', '560');
      return url.href;
    } catch (_) { return ''; }
  }

  function productPrice(product, currency) {
    const amount = Number(product.price);
    if (!Number.isFinite(amount)) return 'View price';
    try {
      const formatted = new Intl.NumberFormat('en-IN', {
        style: 'currency', currency, maximumFractionDigits: 0
      }).format(amount / 100);
      return (product.price_varies ? 'From ' : '') + formatted;
    } catch (_) {
      return '₹' + Math.round(amount / 100).toLocaleString('en-IN');
    }
  }

  function buildCard(product, handle, root, currency) {
    const title = typeof product.title === 'string' ? product.title : 'View product';
    const href = root + 'products/' + encodeURIComponent(handle);
    const image = shopImageURL(product.featured_image || (product.images && product.images[0]));
    const price = productPrice(product, currency);
    // Match the comparison price to the variant behind the displayed minimum price.
    const saleVariant = Array.isArray(product.variants) ? product.variants.find((v) =>
      Number(v.price) === Number(product.price) &&
      Number(v.compare_at_price) > Number(v.price)) : null;
    const compareAt = saleVariant ? Number(saleVariant.compare_at_price) : 0;
    const discountPercent = compareAt > 0 ? Math.round((compareAt - Number(saleVariant.price)) * 100 / compareAt) : 0;

    const item = document.createElement('li');
    item.className = 'aforda-related__item';
    const card = document.createElement('div');
    card.className = 'aforda-rec-card';
    const media = document.createElement('div');
    media.className = 'aforda-rec-card__media';

    const imageLink = document.createElement('a');
    imageLink.className = 'aforda-rec-card__image-link';
    imageLink.href = href;
    imageLink.setAttribute('aria-label', 'View ' + title);

    if (image) {
      const img = document.createElement('img');
      img.className = 'aforda-rec-card__image';
      img.src = image;
      img.alt = title;
      img.loading = 'lazy';
      img.decoding = 'async';
      imageLink.appendChild(img);
    } else {
      const fallback = document.createElement('span');
      fallback.className = 'aforda-rec-card__fallback';
      fallback.textContent = 'AFORDA';
      imageLink.appendChild(fallback);
    }

    media.appendChild(imageLink);
    if (discountPercent > 0 && product.available !== false) {
      const ribbon = document.createElement('span');
      ribbon.className = 'aforda-discount-ribbon';
      ribbon.textContent = 'Save ' + discountPercent + '%';
      ribbon.setAttribute('aria-label', 'Save ' + discountPercent + ' percent');
      media.appendChild(ribbon);
    }

    const heart = document.createElement('button');
    heart.type = 'button';
    heart.className = 'aforda-rec-card__favorite';
    heart.dataset.productId = String(product.id);
    heart.dataset.productTitle = title;
    heart.dataset.productHandle = handle;
    heart.dataset.productUrl = href;
    heart.dataset.productImage = image;
    heart.dataset.productPrice = price;
    heart.setAttribute('aria-label', 'Add ' + title + ' to favourites');
    heart.setAttribute('aria-pressed', 'false');
    heart.title = 'Add to favourites';
    heart.innerHTML = '<svg aria-hidden="true" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
    media.appendChild(heart);

    if (product.available === false) {
      const status = document.createElement('span');
      status.className = 'aforda-rec-card__status aforda-rec-card__status--ribbon';
      status.textContent = 'Sold out';
      media.appendChild(status);
    }

    const details = document.createElement('a');
    details.className = 'aforda-rec-card__details';
    details.href = href;
    const name = document.createElement('span');
    name.className = 'aforda-rec-card__title';
    name.textContent = title;
    const prices = document.createElement('span');
    prices.className = 'aforda-rec-card__prices';
    if (discountPercent > 0) {
      const before = document.createElement('s');
      before.className = 'aforda-rec-card__compare-price';
      before.textContent = productPrice({ price: compareAt, price_varies: false }, currency);
      prices.appendChild(before);
    }
    const amount = document.createElement('span');
    amount.className = 'aforda-rec-card__price';
    amount.textContent = price;
    prices.appendChild(amount);
    details.append(name, prices);
    card.append(media, details);
    item.appendChild(card);
    return item;
  }

  async function init(section) {
    if (section.dataset.afordaRecentlyViewedReady === 'true') return;
    section.dataset.afordaRecentlyViewedReady = 'true';
    const current = section.dataset.productHandle;
    if (!validHandle(current)) return;
    const saved = readHistory().filter((handle) => handle !== current);
    writeHistory([current, ...saved].slice(0, MAX_STORED));
    const limit = Math.max(2, Math.min(6, Number(section.dataset.limit) || 6));
    const handles = saved.slice(0, limit);
    if (!handles.length) return;

    const list = section.querySelector('[data-aforda-recently-viewed-list]');
    if (!list) return;
    const rootRaw = section.dataset.basePath || '/';
    const root = rootRaw.startsWith('/') && !rootRaw.startsWith('//')
      ? rootRaw.replace(/\/?$/, '/') : '/';
    const currency = section.dataset.currency || 'INR';

    const products = await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return null;
        const product = await response.json();
        if (!product || !product.id || !product.title) return null;
        return { handle, product };
      } catch (_) { return null; }
    }));
    if (!section.isConnected) return;
    const cards = products.filter(Boolean).map(({ handle, product }) =>
      buildCard(product, handle, root, currency));
    if (!cards.length) return;
    list.replaceChildren(...cards);
    section.hidden = false;
  }

  function boot(container = document) {
    if (container.matches?.(SELECTOR)) init(container);
    container.querySelectorAll?.(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else boot();

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
